<!--
* @program: office_automation 
* @author: ly
* @component:FcForm 
* @description: 传入的formData 会随着form的修改而改变
* @create: 2021-12-21 18:03
-->
<template>
    <div>
        <a-form layout="horizontal"
                :label-col="labelCol" :wrapper-col="wrapperCol"
                :size="size"
        >
            <div v-for="(column,index) in cols" :key="index">
                <a-form-item >
                    <template #label>
                        {{column.title}}
                        <a-popover v-if="column.tips" trigger="click" placement="bottom">
                            <template #content>
                                <a-list size="small" style="margin: 0" bordered :data-source="column.tips">
                                    <template #renderItem="{item}">
                                        <a-list-item>{{item}}</a-list-item>
                                    </template>
                                </a-list>
                            </template>
                            <a-button  type="link" >
                                <template #icon><InfoCircleOutlined /></template>
                            </a-button>
                        </a-popover>
                    </template>
                    <data-present  :viewModel="viewModel" :record="formData" :column="column" @update="handleUpdate" />
                </a-form-item>
                <a-divider v-if="viewModel" style="margin: 0"/>
            </div>
        </a-form>
        <slot v-if="!viewModel" name="action" :record="formData" :columns="cols"/>
        <slot name="action2" :record="formData" :columns="cols"/>
    </div>
</template>

<script>
    import {computed} from "vue";
    import dataPresent from "../dataPresentType/dataPresent";
    import {InfoCircleOutlined} from "@ant-design/icons-vue";

    export default {
        name: "FcBaseForm",
        props:{
            formColumns:{required:true}, //提供Form的字段集 this.table.getFormColumns()
            formData:{required:false},//提供Form的formData
            viewModel:{required: true},
            spanCol:{required:false},
        },
        emits:["update:formData"],
        provide(){
            return{
                provideTrigger:this.provideTrigger,
                formColumns:computed(()=>this.cols),
                presentType:"form"
            }
        },
        computed:{
            cols(){
                if(!this.viewModel){
                    return  this.formColumns.filter(col=>{
                        return col.editable === true && col.visible;
                    });
                }
                else{
                    return this.formColumns.filter(col=>col.visible);
                }
            },
        },
        components:{
            dataPresent,InfoCircleOutlined
        },
        data(){
            return{
                labelCol:{ span: 8 },
                wrapperCol:{ span: 16 },
                size:"small",
            }
        },
        methods:{
            getSource(){
                return this.formData;
            },
            provideTrigger(action){
                if(action){
                    action(this.formData,this.formColumns);
                }
            },
            handleUpdate(){
                this.$emit("update:formData",this.formData);
            }
        },
        created() {
            if(this.spanCol){
                this.labelCol={ span: 10 };
                this.wrapperCol={ span: 10 };
            }
        }
    }
</script>

<style scoped>

</style>